/** @format */

import React from "react";

export default () => (
  <svg
    width="32"
    height="25"
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="25" fill="#F5F5F5" />
    <g clip-path="url(#clip0_0_1)">
      <rect
        width="1366"
        height="6126"
        transform="translate(-1306 -785)"
        fill="white"
      />
      <path d="M-1306 -685H213V5070H-1306V-685Z" fill="#F9F7F2" />
      <path d="M-1302 -685H64V3813H-1302V-685Z" fill="#F9F7F2" />
      <path d="M-1052 -345H64V3813H-1052V-345Z" fill="#F9F7F2" />
      <g clip-path="url(#clip1_0_1)">
        <g filter="url(#filter0_d_0_1)">
          <path
            d="M3.16455 0.884521H28.8354C30.1572 0.884521 31.1956 1.91082 31.1956 3.13667V21.9353C31.1956 23.1612 30.1572 24.1875 28.8354 24.1875H3.16455C1.8427 24.1875 0.804321 23.1612 0.804321 21.9353V3.13667C0.804321 1.91082 1.8427 0.884521 3.16455 0.884521Z"
            fill="#F9F7F2"
            fill-opacity="0.9"
            stroke="#874439"
          />
          <path
            d="M7.66168 6.21729H11.4385C11.7775 6.21729 12.0973 6.34613 12.3013 6.56584L12.9487 7.26294C13.3561 7.70147 13.9958 7.96004 14.6757 7.96004H23.8478C24.4422 7.96004 24.9269 8.34953 24.9269 8.83265V17.9822C24.9269 18.4653 24.4422 18.8548 23.8478 18.8548H7.66168C7.06722 18.8548 6.58264 18.4653 6.58264 17.9822V7.0899C6.58264 6.60677 7.06722 6.21729 7.66168 6.21729Z"
            stroke="#874439"
            stroke-width="1.51344"
          />
          <path
            d="M19.3519 12.8033V14.025H17.6448V15.4097H16.1274V14.025H14.4202V12.8033H16.1274V11.4287H17.6448V12.8033H19.3519Z"
            fill="#874439"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_0_1"
        x="-3.2927"
        y="-2.2125"
        width="38.5853"
        height="31.497"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.79851" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect
          width="1366"
          height="6126"
          fill="white"
          transform="translate(-1306 -785)"
        />
      </clipPath>
      <clipPath id="clip1_0_1">
        <rect
          width="38"
          height="31"
          fill="white"
          transform="translate(-3 -2)"
        />
      </clipPath>
    </defs>
  </svg>
);
